import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  curve: null,
  oversample: 'none'
};
export var createWaveShaperNodeConstructor = function createWaveShaperNodeConstructor(createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(WaveShaperNode, _noneAudioDestination);

      function WaveShaperNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, WaveShaperNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(WaveShaperNode).call(this, context, 'passive', nativeWaveShaperNode, waveShaperNodeRenderer));
        _this._isCurveNullified = false;
        _this._nativeWaveShaperNode = nativeWaveShaperNode;
        return _this;
      }

      _createClass(WaveShaperNode, [{
        key: "curve",
        get: function get() {
          if (this._isCurveNullified) {
            return null;
          }

          return this._nativeWaveShaperNode.curve;
        },
        set: function set(value) {
          // Bug #103: Safari does not allow to set the curve to null.
          if (value === null) {
            this._isCurveNullified = true;
            this._nativeWaveShaperNode.curve = new Float32Array([0, 0]);
          } else {
            // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
            // Bug #104: Chrome will throw an InvalidAccessError when the curve has less than two samples.
            if (value.length < 2) {
              throw createInvalidStateError();
            }

            this._isCurveNullified = false;
            this._nativeWaveShaperNode.curve = value;
          }
        }
      }, {
        key: "oversample",
        get: function get() {
          return this._nativeWaveShaperNode.oversample;
        },
        set: function set(value) {
          this._nativeWaveShaperNode.oversample = value;
        }
      }]);

      return WaveShaperNode;
    }(noneAudioDestinationNodeConstructor)
  );
};